// "id": 43,
// "title_calculated": "rgwegergwerg",
// "min_price": 1,
// "max_price": 2,
// "default_price": 3,
// "min_term": 2,
// "max_term": 3,
// "default_term": 4,
// "interest_rate": "2.54",
// "administration_fee": "5.77",
// "issuance_fee": "8.43",
// "repayment_type": 1,
// "default_repayment_type": "anuitate",
// "financial_items": {
//   "title": "wqfwefsdfgsfg",
//   "items": [
//     {
//       "id": 35,
//       "text": "f1"
//     },
//     {
//       "id": 36,
//       "text": "f2"
//     },
//     {
//       "id": 37,
//       "text": "f3"
//     }
//   ]
// },
// "credit_history_items": {
//   "title": "sdfgdfgsdfg",
//   "items": [
//     {
//       "id": 31,
//       "text": "c1"
//     },
//     {
//       "id": 32,
//       "text": "c2"
//     }
//   ]
// },
// "additional_conditions": [
//   {
//     "id": 14,
//     "text": "rthrthrthrth"
//   },
//   {
//     "id": 15,
//     "text": ";o;ioyjktyjtyhjtyjtyj"
//   }
// ]

export default function ({ data = {}, single = false, applyPageUrl = '' }) {
  let amountDebounceTimer = null
  let periodDebounceTimer = null

  return {
    single,
    groups: data.groups,
    item: data.item,
    applyPageUrl,
    selectedGroupIndex: 0,
    selectedItemIndex: 0,
    isScheduleDialogOpen: false,
    amount: 0,
    period: 0,
    financialData: null,
    creditHistory: null,
    financial_item_id: null,
    credit_history_item_id: null,

    // Handle amount input - extract digits and limit to max
    handleAmountInput(value) {
      const maxDigits = String(this.selectedProduct?.max_price || 99999999).length
      let digits = (value || '').replace(/\D/g, '')
      
      // Limit to max digits
      if (digits.length > maxDigits) {
        digits = digits.slice(0, maxDigits)
      }
      
      // Store raw number (will be formatted on blur)
      this.amount = digits
      this.scheduleAmountCorrection()
    },

    // Format amount display with thousands separator
    formatAmountDisplay() {
      if (this.amount) {
        this.amount = this.formatNumber(this.amount)
      }
    },

    // Handle period input - extract digits and limit to max
    handlePeriodInput(value) {
      const maxDigits = String(this.selectedProduct?.max_term || 999).length
      let digits = (value || '').replace(/\D/g, '')
      
      // Limit to max digits
      if (digits.length > maxDigits) {
        digits = digits.slice(0, maxDigits)
      }
      
      this.period = digits
      this.schedulePeriodCorrection()
    },

    // Debounced auto-correction methods
    scheduleAmountCorrection() {
      clearTimeout(amountDebounceTimer)
      amountDebounceTimer = setTimeout(() => {
        this.enforceAmountBounds()
      }, 1000)
    },
    schedulePeriodCorrection() {
      clearTimeout(periodDebounceTimer)
      periodDebounceTimer = setTimeout(() => {
        this.enforcePeriodBounds()
      }, 1000)
    },
    enforceAmountBounds() {
      if (!this.selectedProduct) return
      const num = this.amountNumber
      if (num < this.selectedProduct.min_price) {
        this.amount = this.formatNumber(this.selectedProduct.min_price)
      } else if (num > this.selectedProduct.max_price) {
        this.amount = this.formatNumber(this.selectedProduct.max_price)
      }
    },
    enforcePeriodBounds() {
      if (!this.selectedProduct) return
      const num = parseInt(this.period) || 0
      if (num < this.selectedProduct.min_term) {
        this.period = this.selectedProduct.min_term
      } else if (num > this.selectedProduct.max_term) {
        this.period = this.selectedProduct.max_term
      }
    },

    init() {
      if (this.selectedProduct) {
        this.amount = this.formatNumber(this.selectedProduct.default_price)
        this.period = this.selectedProduct.default_term
      }

      const store = this.$store.creditApplicationDraft
      // Only enable two-way sync on product page (where #apply form exists)
      // On home page, we only sync when Apply button is clicked
      const isProductPage = !!document.getElementById('apply')

      if (store && isProductPage) {
        // Sync calculator → store when values change (for product page form)
        this.$watch('amount', () => {
          const numValue = String(this.amountNumber)
          if (store.amount !== numValue) {
            store.amount = numValue
          }
          // Update calculated values when amount changes
          this.syncCalculatedValuesToStore()
        })
        this.$watch('period', () => {
          const strValue = String(this.period)
          if (store.period !== strValue) {
            store.period = strValue
          }
          // Update calculated values when period changes
          this.syncCalculatedValuesToStore()
        })
        this.$watch('selectedProduct', () => {
          if (this.selectedProduct) {
            store.product_id = this.selectedProduct.id || null
            store.product = this.selectedProduct.title_calculated || ''
          }
          // Update calculated values when product changes
          this.syncCalculatedValuesToStore()
        })
        this.$watch('financial_item_id', () => {
          // Update store when financial item changes
          this.syncCalculatedValuesToStore()
        })
        this.$watch('credit_history_item_id', () => {
          // Update store when credit history item changes
          this.syncCalculatedValuesToStore()
        })

        // Sync store → calculator when values change (from form inputs)
        this.$watch('$store.creditApplicationDraft.amount', (value) => {
          if (value && this.amountNumber !== parseFloat(value)) {
            this.amount = this.formatNumber(value)
          }
        })
        this.$watch('$store.creditApplicationDraft.period', (value) => {
          if (value && parseInt(this.period) !== parseInt(value)) {
            this.period = parseInt(value)
          }
        })

        // Initial sync to store (product page only)
        if (this.selectedProduct) {
          store.product_id = this.selectedProduct.id || null
          store.product = this.selectedProduct.title_calculated || ''
          store.amount = String(this.amountNumber)
          store.period = String(this.period)
          // Restore radio button selections from store if they exist
          if (store.financial_item_id !== null && store.financial_item_id !== undefined) {
            this.financial_item_id = store.financial_item_id
          }
          if (store.credit_history_item_id !== null && store.credit_history_item_id !== undefined) {
            this.credit_history_item_id = store.credit_history_item_id
          }
          this.syncCalculatedValuesToStore()
        }
      } else {
        // On home page, restore radio button selections from store if they exist
        const store = this.$store.creditApplicationDraft
        if (store) {
          if (store.financial_item_id !== null && store.financial_item_id !== undefined) {
            this.financial_item_id = store.financial_item_id
          }
          if (store.credit_history_item_id !== null && store.credit_history_item_id !== undefined) {
            this.credit_history_item_id = store.credit_history_item_id
          }
        }
      }
    },

    syncCalculatedValuesToStore() {
      const store = this.$store.creditApplicationDraft
      if (!store || !this.selectedProduct) return

      store.setFromCalculator({
        product_id: this.selectedProduct.id || null,
        product: this.selectedProduct.title_calculated || '',
        amount: String(this.amountNumber),
        period: String(this.period),
        monthly_payment: this.monthlyPaymentWithFee || null,
        total_payment: this.totalCreditValue || null,
        total_interest: this.totalInterest || null,
        interest_rate: this.effectiveInterestRate !== undefined && this.effectiveInterestRate !== null ? this.effectiveInterestRate : null,
        administration_fee: this.selectedProduct.administration_fee !== undefined && this.selectedProduct.administration_fee !== null ? this.selectedProduct.administration_fee : null,
        issuance_fee: this.selectedProduct.issuance_fee !== undefined && this.selectedProduct.issuance_fee !== null ? this.selectedProduct.issuance_fee : null,
        dae: this.dae || null,
        financial_item_id: this.financial_item_id !== undefined && this.financial_item_id !== null ? this.financial_item_id : null,
        credit_history_item_id: this.credit_history_item_id !== undefined && this.credit_history_item_id !== null ? this.credit_history_item_id : null
      })
    },

    syncToStore() {
      this.syncCalculatedValuesToStore()
    },

    apply() {
      // Save current calculator values to store
      this.syncToStore()

      // Check if there's an #apply section on the page
      const applySection = document.getElementById('apply')
      if (applySection) {
        // On product page - scroll to the form
        applySection.scrollIntoView({ behavior: 'smooth' })
      } else if (this.applyPageUrl) {
        // On home page - navigate to apply page with prefill flag
        const url = new URL(this.applyPageUrl, window.location.origin)
        url.searchParams.set('prefill', '1')
        window.location.href = url.toString()
      }
    },

    get activeCategoryTab() {
      return 'category-' + this.selectedGroupIndex
    },

    get activeProductTab() {
      return 'product-' + this.selectedGroupIndex + '-' + this.selectedItemIndex
    },

    selectGroup(index) {
      if (this.selectedGroupIndex === index) return
      this.selectedGroupIndex = index
      this.selectedItemIndex = 0
      this.$nextTick(() => {
        const product = this.selectedProduct
        if (product) {
          this.amount = this.formatNumber(product.default_price || product.min_price || 0)
          this.period = Math.min(
            Math.max(product.default_term || product.min_term || 0, product.min_term || 0),
            product.max_term || 999
          )
          // Reset radio button selections when group changes
          this.financial_item_id = null
          this.credit_history_item_id = null
        }
      })
    },

    selectProduct(index) {
      if (this.selectedItemIndex === index) return
      this.selectedItemIndex = index
      this.$nextTick(() => {
        const product = this.selectedProduct
        if (product) {
          this.amount = this.formatNumber(product.default_price || product.min_price || 0)
          this.period = Math.min(
            Math.max(product.default_term || product.min_term || 0, product.min_term || 0),
            product.max_term || 999
          )
          // Reset radio button selections when product changes
          this.financial_item_id = null
          this.credit_history_item_id = null
        }
      })
    },

    get selectedProduct() {
      if (single) return this.item
      if (!this.groups || !this.groups[this.selectedGroupIndex]) return null
      const products = this.groups[this.selectedGroupIndex].products
      if (!products || !products[this.selectedItemIndex]) return null
      return products[this.selectedItemIndex]
    },

    // Convert amount string (with spaces) to number
    get amountNumber() {
      if (typeof this.amount === 'string') {
        // Remove all types of spaces including non-breaking space (used by $money mask)
        return parseFloat(this.amount.replace(/[\s\u00A0]/g, '')) || 0
      }
      return parseFloat(this.amount) || 0
    },

    // Get the effective interest rate: from selected financial item (if not null), else product default
    get effectiveInterestRate() {
      if (this.financial_item_id !== null && this.financial_item_id !== undefined) {
        const items = this.selectedProduct?.financial_items?.items
        if (items) {
          const item = items.find(i => i.id == this.financial_item_id)
          if (item && item.interest_rate !== null && item.interest_rate !== undefined) {
            return item.interest_rate
          }
        }
      }
      return this.selectedProduct?.interest_rate ?? null
    },

    // Get interest rate as decimal (e.g., 2.54% -> 0.0254)
    // Dobândă anuală (Rata dobânzii) - % pe an
    get interestRateDecimal() {
      return parseFloat(this.effectiveInterestRate || 0) / 100
    },

    // Get monthly interest rate
    get monthlyInterestRate() {
      return this.interestRateDecimal / 12
    },

    // Get administration fee as decimal (monthly commission percent)
    // Comision de administrare (Comision lunar) - % din suma creditului
    get administrationFeeDecimal() {
      return parseFloat(this.selectedProduct?.administration_fee || 0) / 100
    },

    // Get monthly commission value (fixed amount per month)
    get monthlyCommissionValue() {
      return this.roundMoney(this.amountNumber * this.administrationFeeDecimal)
    },

    // Get issuance fee as decimal (release commission percent)
    // Comision eliberare - % din suma creditului
    get issuanceFeeDecimal() {
      return parseFloat(this.selectedProduct?.issuance_fee || 0) / 100
    },

    // Get issuance fee amount (release commission value)
    get issuanceFeeAmount() {
      return this.roundMoney(this.amountNumber * this.issuanceFeeDecimal)
    },

    // Get repayment type: 'anuitate' or 'principal_constant'
    get repaymentType() {
      if (!this.selectedProduct) return 'anuitate'
      const type = this.selectedProduct.repayment_type
      if (type === 2) return 'principal_constant'
      return 'anuitate'
    },

    // Calculate base monthly payment (annuity formula) - without commissions
    // For anuitate: R = P * [ i * (1+i)^n ] / [ (1+i)^n - 1 ]
    // For principal_constant: not used, calculated per month
    get baseMonthlyPayment() {
      if (this.repaymentType === 'principal_constant') {
        // For principal constant, this is not used directly
        // Payment varies each month, calculated in paymentSchedule
        return 0
      }

      const P = this.amountNumber
      const i = this.monthlyInterestRate
      const n = Math.min(Math.max(Math.floor(this.period || 0), 0), 600)

      if (P <= 0 || n <= 0 || !isFinite(P) || !isFinite(n)) return 0

      if (i <= 0 || !isFinite(i)) {
        return this.roundMoney(P / n)
      }

      try {
        const numerator = i * Math.pow(1 + i, n)
        const denominator = Math.pow(1 + i, n) - 1
        if (!isFinite(denominator) || denominator === 0) return 0
        const R = P * (numerator / denominator)
        return isFinite(R) ? this.roundMoney(R) : 0
      } catch (e) {
        return 0
      }
    },

    // Calculate monthly payment with administration fee (for display)
    // For anuitate: base payment + monthly commission
    // For principal_constant: first month payment (includes all fees)
    get monthlyPaymentWithFee() {
      if (this.repaymentType === 'principal_constant') {
        const schedule = this.paymentSchedule
        if (schedule && schedule.length > 0) {
          return schedule[0].totalPayment
        }
        // Fallback calculation for principal constant
        const principalConstant = this.roundMoney(this.amountNumber / Math.max(this.period, 1))
        const firstInterest = this.roundMoney(this.amountNumber * this.monthlyInterestRate)
        return this.roundMoney(principalConstant + firstInterest + this.monthlyCommissionValue + this.issuanceFeeAmount)
      }
      return this.roundMoney(this.baseMonthlyPayment + this.monthlyCommissionValue)
    },

    // Calculate total values from payment schedule
    get paymentScheduleTotals() {
      const schedule = this.paymentSchedule
      if (!schedule || schedule.length === 0) {
        return {
          totalPayment: 0,
          totalInterest: 0,
          totalPrincipal: 0,
          totalMonthlyCommission: 0,
          totalReleaseCommission: 0
        }
      }

      const totals = schedule.reduce((acc, payment) => {
        acc.totalPayment += payment.totalPayment
        acc.totalInterest += payment.interest
        acc.totalPrincipal += payment.principalPayment
        acc.totalMonthlyCommission += payment.administrationFee
        acc.totalReleaseCommission += payment.releaseCommission || 0
        return acc
      }, {
        totalPayment: 0,
        totalInterest: 0,
        totalPrincipal: 0,
        totalMonthlyCommission: 0,
        totalReleaseCommission: 0
      })

      // Round all totals for consistency with PHP
      return {
        totalPayment: this.roundMoney(totals.totalPayment),
        totalInterest: this.roundMoney(totals.totalInterest),
        totalPrincipal: this.roundMoney(totals.totalPrincipal),
        totalMonthlyCommission: this.roundMoney(totals.totalMonthlyCommission),
        totalReleaseCommission: this.roundMoney(totals.totalReleaseCommission)
      }
    },

    // Calculate total interest paid
    get totalInterest() {
      return this.paymentScheduleTotals.totalInterest
    },

    // Calculate total administration fees
    get totalAdministrationFees() {
      return this.paymentScheduleTotals.totalMonthlyCommission
    },

    // Calculate total credit value (sum of all payments from schedule)
    get totalCreditValue() {
      return this.paymentScheduleTotals.totalPayment
    },

    // Helper: check if year is a leap year
    isLeapYear(year) {
      return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)
    },

    // Calculate DAE using BNM/European formula with Actual/Actual day count
    // Matches dae.md methodology: interest calculated using actual days / year days (365 or 366)
    get dae() {
      const principal = this.amountNumber
      const issuanceFee = this.issuanceFeeAmount
      const periods = Math.min(Math.max(Math.floor(this.period || 0), 0), 600)
      const annualRate = this.interestRateDecimal
      const monthlyRate = this.monthlyInterestRate
      const monthlyCommission = this.monthlyCommissionValue

      if (principal <= 0 || periods <= 0) return 0

      // Net amount received by consumer at time 0 (after issuance fee deduction)
      const netPrincipal = principal - issuanceFee

      // Generate schedule using dae.md methodology: Actual/Actual for interest
      const startDate = new Date()
      startDate.setHours(12, 0, 0, 0)

      // Calculate annuity using standard formula (same as dae.md)
      const annuity = this.baseMonthlyPayment

      const schedule = []
      let balance = principal

      for (let month = 1; month <= periods; month++) {
        const payDate = new Date(startDate)
        payDate.setMonth(payDate.getMonth() + month)

        const prevDate = month === 1 ? startDate : (() => {
          const d = new Date(startDate)
          d.setMonth(d.getMonth() + month - 1)
          return d
        })()

        // Actual days between payments
        const daysDiff = Math.round((payDate - prevDate) / 86400000)
        // Year days based on payment year (365 or 366)
        const yearDays = this.isLeapYear(payDate.getFullYear()) ? 366 : 365

        let interest, principalPaid, totalPay

        if (this.repaymentType === 'anuitate') {
          // Interest using Actual/Actual (like dae.md)
          interest = this.roundMoney(balance * (daysDiff / yearDays) * annualRate)

          if (month === periods) {
            // Last month: pay off remaining balance
            principalPaid = this.roundMoney(balance)
            totalPay = this.roundMoney(principalPaid + interest + monthlyCommission)
          } else {
            principalPaid = this.roundMoney(annuity - interest)
            totalPay = this.roundMoney(annuity + monthlyCommission)
          }
        } else {
          // principal_constant: interest using Actual/Actual
          interest = this.roundMoney(balance * (daysDiff / yearDays) * annualRate)
          const principalConstant = this.roundMoney(principal / periods)

          if (month === periods) {
            principalPaid = this.roundMoney(balance)
          } else {
            principalPaid = this.roundMoney(Math.min(principalConstant, balance))
          }
          totalPay = this.roundMoney(principalPaid + interest + monthlyCommission)
        }

        balance = this.roundMoney(balance - principalPaid)

        // Calculate cumulative days from start for DAE discounting
        const cumulativeDays = Math.round((payDate - startDate) / 86400000)

        schedule.push({
          totalPay,
          cumulativeDays
        })
      }

      // Calculate DAE using binary search
      let low = 0.0
      let high = 5.0 // 500%
      let dae = null
      const tolerance = 1e-12
      const maxIterations = 500

      for (let iteration = 0; iteration < maxIterations; iteration++) {
        const mid = (low + high) / 2
        let npv = netPrincipal

        for (const row of schedule) {
          const timeYears = row.cumulativeDays / 365
          npv -= row.totalPay / Math.pow(1 + mid, timeYears)
        }

        if (Math.abs(npv) < tolerance) {
          dae = mid
          break
        }

        if (npv > 0) {
          high = mid
        } else {
          low = mid
        }

        dae = mid
      }

      return dae !== null ? dae * 100 : 0
    },

    // Generate payment schedule following dae.md methodology
    // Uses Actual/Actual day count for interest calculation
    // Last month payment is adjusted to exactly clear remaining balance
    get paymentSchedule() {
      const schedule = []
      const amount = this.amountNumber
      const periods = Math.min(Math.max(Math.floor(this.period || 0), 0), 600)
      const annualRate = this.interestRateDecimal
      const basePayment = this.baseMonthlyPayment
      const monthlyCommissionValue = this.monthlyCommissionValue
      const releaseCommissionValue = this.issuanceFeeAmount
      const repaymentType = this.repaymentType

      if (periods <= 0 || amount <= 0 || !isFinite(periods)) return schedule

      let balance = amount
      const principalConstant = periods > 0 ? this.roundMoney(amount / periods) : 0

      // Start date for payment schedule (1st of next month for display)
      const displayStartDate = new Date()
      displayStartDate.setMonth(displayStartDate.getMonth() + 1)
      displayStartDate.setDate(1)

      // Calculation start date (today at noon, for interest calculation)
      const calcStartDate = new Date()
      calcStartDate.setHours(12, 0, 0, 0)

      for (let month = 1; month <= periods; month++) {
        const isLastMonth = month === periods

        // Calculate payment date for interest calculation
        const payDate = new Date(calcStartDate)
        payDate.setMonth(payDate.getMonth() + month)

        const prevDate = month === 1 ? calcStartDate : (() => {
          const d = new Date(calcStartDate)
          d.setMonth(d.getMonth() + month - 1)
          return d
        })()

        // Actual/Actual: days between payments / year days (365 or 366)
        const daysDiff = Math.round((payDate - prevDate) / 86400000)
        const yearDays = this.isLeapYear(payDate.getFullYear()) ? 366 : 365

        // Interest using Actual/Actual (like dae.md)
        const interest = this.roundMoney(balance * (daysDiff / yearDays) * annualRate)

        let principal
        let paymentForMonth

        if (repaymentType === 'anuitate') {
          if (isLastMonth) {
            // Last month: principal = remaining balance to clear it exactly
            principal = this.roundMoney(balance)
            paymentForMonth = this.roundMoney(principal + interest)
          } else {
            principal = this.roundMoney(basePayment - interest)
            paymentForMonth = basePayment
            // Ensure principal doesn't exceed balance (safety check)
            if (principal > balance) {
              principal = this.roundMoney(balance)
              paymentForMonth = this.roundMoney(interest + principal)
            }
          }
        } else {
          // principal_constant
          if (isLastMonth) {
            // Last month: principal = remaining balance to clear it exactly
            principal = this.roundMoney(balance)
          } else {
            principal = this.roundMoney(Math.min(principalConstant, balance))
          }
          paymentForMonth = this.roundMoney(principal + interest)
        }

        const balanceAfter = isLastMonth ? 0 : Math.max(0, this.roundMoney(balance - principal))
        const releaseCommission = month === 1 ? releaseCommissionValue : 0
        const rateTotala = this.roundMoney(paymentForMonth + monthlyCommissionValue + releaseCommission)

        // Display date (1st of each month)
        const displayDate = new Date(displayStartDate)
        displayDate.setMonth(displayStartDate.getMonth() + month - 1)

        schedule.push({
          month: month,
          date: displayDate.toLocaleDateString('ro-RO', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          }),
          remainingPrincipal: balanceAfter,
          interest: interest,
          principalPayment: principal,
          administrationFee: monthlyCommissionValue,
          releaseCommission: releaseCommission,
          totalPayment: rateTotala
        })

        balance = balanceAfter
      }

      return schedule
    },

    // Format number with spaces as thousand separators (no decimals) - for input fields
    formatNumber(value) {
      if (!value && value !== 0) return '0'
      // Strip any existing spaces/formatting before parsing
      const cleaned = String(value).replace(/[\s\u00A0]/g, '')
      const num = parseFloat(cleaned)
      if (isNaN(num)) return '0'
      return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    },

    // Format money with spaces as thousand separators and 2 decimal places (like PHP format_money)
    formatMoney(value) {
      if (!value && value !== 0) return '0.00'
      const num = parseFloat(value)
      if (isNaN(num)) return '0.00'
      // Round to 2 decimals, then format with space as thousand separator
      const fixed = this.roundMoney(num).toFixed(2)
      const [intPart, decPart] = fixed.split('.')
      const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      return formattedInt + '.' + decPart
    },

    // Format percentage
    formatPercentage(value) {
      if (!value && value !== 0) return '0%'
      return parseFloat(value).toFixed(2) + '%'
    },

    // Round to 2 decimal places (like PHP round_money)
    roundMoney(value) {
      return Math.round(value * 100) / 100
    },

    openScheduleDialog() {
      this.isScheduleDialogOpen = true
    },
    closeScheduleDialog() {
      this.isScheduleDialogOpen = false
    },
    toggleScheduleDialog() {
      this.isScheduleDialogOpen = !this.isScheduleDialogOpen
    },
    async downloadSchedulePdf() {
      if (!this.selectedProduct) return

      const payload = {
        product: {
          id: this.selectedProduct.id,
          title_product: this.selectedProduct.title_product,
          title: this.selectedProduct.title_calculated,
          interest_rate: this.selectedProduct.interest_rate,
          administration_fee: this.selectedProduct.administration_fee,
          issuance_fee: this.selectedProduct.issuance_fee,
          repayment_type: this.repaymentType,
        },
        amount: this.amountNumber,
        period: parseInt(this.period),
        totals: {
          monthly_payment: this.monthlyPaymentWithFee,
          total_payment: this.totalCreditValue,
          total_interest: this.totalInterest,
          total_principal: this.paymentScheduleTotals.totalPrincipal,
          total_commission: this.totalAdministrationFees,
          dae: this.dae,
        },
        schedule: this.paymentSchedule,
      }

      const response = await fetch('/product/payment-schedule/pdf/prepare', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify(payload),
      })

      const { token } = await response.json()

      window.location.href = `/product/payment-schedule/pdf/${token}`
    },
    async sendCalculatorData() {
      if (!this.selectedProduct) return

      const calculatorData = {
        product: {
          id: this.selectedProduct.id,
          title_product: this.selectedProduct.title_product,
          title: this.selectedProduct.title_calculated,
          interest_rate: this.selectedProduct.interest_rate,
          administration_fee: this.selectedProduct.administration_fee,
          issuance_fee: this.selectedProduct.issuance_fee,
          repayment_type: this.repaymentType,
        },
        amount: this.amountNumber,
        period: parseInt(this.period),
        totals: {
          monthly_payment: this.monthlyPaymentWithFee,
          total_payment: this.totalCreditValue,
          total_interest: this.totalInterest,
          total_principal: this.paymentScheduleTotals.totalPrincipal,
          total_commission: this.totalAdministrationFees,
          dae: this.dae,
        },
        schedule: this.paymentSchedule,
      }

      const response = await fetch('/product/pdf/prepare', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify(calculatorData),
      })

      const { token } = await response.json()

      window.open(`/product/pdf/${token}`, '_blank')
    }
  }
}
